import Button from "@material-ui/core/Button";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { makeStyles } from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";
import Help from "@material-ui/icons/Help";
import _ from 'lodash';
import React, { useEffect, useState } from "react";
import {
  bulkEditMarker, omitQuestion, resetMarkerKey
} from "../../actions";
import { connect } from 'react-redux';

const helpText =
  "English words only. " +
  "Remember to insert what to take picture of in the text field above, e.g., 'car' or 'tree'";

const useStyles = makeStyles((theme) => ({
  form: {
    "& > *": {
      margin: theme.spacing(1),
      width: "90%",
    },
  },
  checkboxes: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
}));

const QuestionTabFooter = (props) => {
  const classes = useStyles();
  const [questionKeys, setquestionKeys] = useState({});

  useEffect(() => {
    setquestionKeys(_.mapValues(_.pickBy(props.marker, (v, key) => key.includes('question')), () => ''));
  }, [props.marker])

  return (
    <div className={classes.checkboxes}>
    <Tooltip title={helpText}>
      <Help />
    </Tooltip>
    <div className={classes.checkboxes}>
      <FormControlLabel
        control={
          <Checkbox
            checked={props.marker.photo || false}
            onChange={({ target: { checked } }) => {
              props.bulkEditMarker({
                key: props.marker.key,
                value: {
                  photo: checked,
                  takeTeamPhoto: false,
                },
              });
            }}
            color="primary"
          />
        }
        label="Use AI Camera"
      />
    </div>
    <FormControlLabel
      control={
        <Checkbox
          checked={props.marker.takeTeamPhoto || false}
          onChange={({ target: { checked } }) => {
            if (!checked) {
              props.bulkEditMarker({
                key: props.marker.key,
                value: {
                  takeTeamPhoto: checked,
                  photo: false,
                  answer: [],
                  ...questionKeys
                },
              });
            } else {
              props.bulkEditMarker({
                key: props.marker.key,
                value: {
                  takeTeamPhoto: checked,
                  photo: false,
                  ...questionKeys
                },
              });
            }
          }}
          color="primary"
        />
      }
      label="Ask for Team Photo"
    />
    <Button
      onClick={() => {
        props.omitQuestion(props.marker.key, [
          ...Object.keys(questionKeys),
          "answer",
          "photo",
          "takeTeamPhoto",
        ]);

        props.resetMarkerKey();
      }}
      color="secondary"
    >
      Delete Question
    </Button>
  </div>
  )
}

export default connect(null, { omitQuestion, bulkEditMarker, resetMarkerKey })(QuestionTabFooter);